/* eslint-disable id-length */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { Component, ErrorInfo, ReactNode } from 'react';
import Error from 'next/error';
import Header from '../../layouts/_components/pyr/Header';
import Footer from '../../layouts/_components/agd/Footer';

type Props = {
  children?: ReactNode;
};

type State = {
  hasError: boolean;
};

// api errors occured on client (refetch on mount getShoppingCart when api doesn't work as an example)
class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  // public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
  //   console.error('Uncaught error:', error, errorInfo);
  // }

  public render() {
    if (this.state.hasError) {
      return (
        <>
          <Header searchComponent menuComponent freeSHTotalRetail={null} />
          <Error statusCode={500} />
          <Footer />
        </>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
